import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";

interface StatusWithDotProps {
  status: string;
}

export const LeadStatusCell = (value: string) => {
  return <StatusWithDot status={value} />;
};

const StatusWithDot: React.FC<StatusWithDotProps> = ({ status }) => {
  const { t } = useTranslation(["profile"]);
  const langTheme = useLanguageTheme();

  let dotColor = "";
  switch (status.toLowerCase()) {
    case "active":
      dotColor = "rgba(101, 201, 51, 1)";
      break;
    case "purchased":
      dotColor = "rgba(104, 189, 253, 1)";
      break;
    case "expired":
      dotColor = "rgba(253, 104, 104, 1)";
      break;
    case "expired(purchased)":
      dotColor = "hsl(217, 60.00%, 66.70%)";
      break;
    default:
      dotColor = "#9E9E9E";
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <Box
        sx={{
          width: "11px",
          height: "11px",
          borderRadius: "50%",
          backgroundColor: dotColor,
          flexShrink: 0,
        }}
      />
      <Typography
        component="span"
        sx={{
          fontFamily: langTheme.mainFont(),
          lineHeight: "16px",
        }}
      >
        {t(status)}
      </Typography>
    </Box>
  );
};

export default StatusWithDot;
